import Member from '../Member';

export default class TrainingReply
{
    static RESPONSE_ACCEPTED = 'accepted';
    static RESPONSE_REJECTED = 'rejected';
    static RESPONSE_UNSURE = 'unsure';

    static fromData(data)
    {
        if (!data) {
            return;
        }

        let trainingOfferingReply = new TrainingReply();
        trainingOfferingReply.id = data.id;
        trainingOfferingReply.member = Member.fromData(data.member);
        trainingOfferingReply.response = data.response;
        trainingOfferingReply.comment = data.comment;
        trainingOfferingReply.respondedAt = data.respondedAt;
        trainingOfferingReply.bookedByClub = data.bookedByClub;
        trainingOfferingReply.attendeeStatus = data.attendeeStatus;
        trainingOfferingReply.checked = false;
        trainingOfferingReply.canViewShortProfile = data.canViewShortProfile;

        return trainingOfferingReply;
    }

    isAccepted()
    {
        return this.response === TrainingReply.RESPONSE_ACCEPTED;
    }

    isRejected()
    {
        return this.response === TrainingReply.RESPONSE_REJECTED;
    }

    isUnsure()
    {
        return this.response === TrainingReply.RESPONSE_UNSURE;
    }
}
